<app-modal
  [icone]="'access'"
  (closeModal)="modalTrocarSenhaService.toggleModal()"
  [isOpen]="modalTrocarSenhaService.mostrarModal()"
  [size]="'sm'"
  [closeOverlayClick]="false">
  <app-modal-header>Trocar senha</app-modal-header>
  <ng-container modalBody>
    <form [formGroup]="formulario">
      <div class="w-full">
        <label appLabel for="senhaAtual">Senha atual</label>
        <input
          appInput
          class="mb-10 w-full"
          type="password"
          autocomplete="off"
          id="senhaAtual"
          formControlName="senhaAtual"
          />
      </div>
      <div class="w-full">
        <label appLabel for="novaSenha">Nova Senha</label>
        <input
          appInput
          class="mb-2 w-full"
          type="password"
          autocomplete="off"
          id="novaSenha"
          formControlName="novaSenha"
          />
      </div>

      <div class="w-full">
        <label appLabel for="confirmarNovaSenha">Confirme sua senha</label>
        <input
          appInput
          class="mb-2 w-full"
          type="password"
          formControlName="confirmarNovaSenha"
          autocomplete="off"
          />
      </div>
    </form>
    @if (errosApi.length > 0) {
      <div class="mt-2 text-sm text-red-500">
        <ul>
          @for (erro of errosApi; track erro) {
            <li class="text-xs">* {{ erro }}</li>
          }
        </ul>
      </div>
    }
  </ng-container>
  <app-modal-footer>
    <div class="flex gap-2">
      <button
        appButton
        class="w-full"
        variant="secondary"
        (click)="modalTrocarSenhaService.toggleModal()"
        >
        Cancelar
      </button>
      <button
        appButton
        class="w-full"
        variant="default"
        [disabled]="formulario.invalid"
        (click)="trocarSenha()"
        >
        Trocar senha
      </button>
    </div>
  </app-modal-footer>
</app-modal>
